export const ID_PROVINCE_QUEBEC_CONFIG_WEB = "A72DC95F-AE7A-E211-8D2C-685D4378BA44".toLowerCase();
export const ID_PAYS_CANADA_CONFIG_WEB = "132BC95F-AE7A-E211-8D2C-685D4378BA44".toLowerCase();